<template>
	<label class="label" :for="forElementId">{{ labelText }}</label>
</template>

<script>
export default {
	name: 'Label',
	props: {
		labelText: {
			type: String,
			default: ''
		},
		forElementId: {
			type: [String, Number],
			default: ''
		}
	}
};
</script>

<style lang="scss" scoped>
.label {
	display: block;
	font-size: $label-font-size;
	font-weight: $label-font-weight;
	color: $label-font-color;
	margin-bottom: $gutter-sm;
}
</style>
